import React from 'react';

import { Image } from '@mantine/core';

import cx from './Certification.module.scss';

interface Props {
    size?: number;
    dimmed?: boolean;
}

const EmergeAlliance = ({ size = 32, dimmed = false }: Props) => {
    return (
        <Image
            src={'/images/emerge-alliance.png'}
            w={(417 / 136) * size}
            h={size}
            alt="EMerge Alliance"
            classNames={cx}
            data-dimmed={dimmed}
        />
    );
};

export { EmergeAlliance };
